import React, {useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import SearchListItemResult from "../SearchComponent/SearchListItemResult";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import AlertComponent from "../../AlertComponent";
import {useUser} from "../../../hooks/useUser";
import {useAuth} from "../../../context/auth-context";
import {useVirtualizer} from "@tanstack/react-virtual";
import InfiniteListLastItem from "../../InfiniteListLastItem";
import {getUrl, PWAUrls} from "../../../config/urls";

const ITEM_HEIGHT_XS = 106;
const ITEM_HEIGHT_MD = 106;

const ListComponent = ({i18n, items = null, nbHits, loadMore = null, hasNextPage = null, screenName, showPrice, forceSmall= false, isFetchingNextPage = null}) => {
    const localStorageItemKey = screenName + '-' + 'OME_searchListItemResult';
    const offsetIndex = localStorage.getItem(localStorageItemKey) ? parseInt(localStorage.getItem(localStorageItemKey)) : 0;
    const { width } = useWindowDimensions();
    const itemHeight = width < 960 || forceSmall ? ITEM_HEIGHT_XS : ITEM_HEIGHT_MD;
    const parentRef = React.useRef();
    const rowVirtualizer = useVirtualizer({
        count: hasNextPage ? items.length + 1 : items.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => itemHeight,
        overscan: 5,
    });

    React.useEffect(() => {
        const [lastItem] = [...rowVirtualizer.getVirtualItems()].reverse();
        if (!lastItem) {
            return
        }

        if (lastItem.index >= items.length - 1 &&
            nbHits > items.length &&
            hasNextPage &&
            !isFetchingNextPage) {
            loadMore()
        }

        if (offsetIndex > 0) {
            if (offsetIndex > items.length-1
                && nbHits > items.length) {
                loadMore();
            }
            if (offsetIndex < items.length) {
                 setTimeout(() => {
                     rowVirtualizer.scrollToIndex(offsetIndex, {align: 'start'});
                     localStorage.removeItem(localStorageItemKey);
                 }, 500);
            }
        }
    }, [
        hasNextPage,
        loadMore,
        items.length,
        isFetchingNextPage,
        rowVirtualizer.getVirtualItems(),
    ]);

    const auth = useAuth();
    const { t } = useTranslation();
    const {data} = useUser(auth.user?.email, i18n.language);

    const [showAuthAlert, setShowAuthAlert] = useState(false);

    if (showAuthAlert) {
        return (
            <AlertComponent
                title={t("AlertComponent.login.addToCart.title")}
                message={t("AlertComponent.login.addToCart.message")}
                severity={'warning'}
                reload={false}
                backgroundIcon={'book'}
                ctaLabel={t("TopoValidationScreen.alert.guestCta")}
                ctaIcon={'sign-in-alt'}
                ctaLinkTo={getUrl(PWAUrls.USER_LOGIN, {lng: i18n.language})}
                backButtonShow={true}
                backButtonCallback={() => {setShowAuthAlert(false)}}
            />
        )
    }

    //Autosizer can't be used in flexbox grow container
    const virtualItems = rowVirtualizer.getVirtualItems();

    return (<div
            ref={parentRef}
            className="List"
            style={{
                height: `100%`,
                width: `100%`,
                overflowY: 'auto',
                contain: 'strict',
            }}>
        {virtualItems.length > 0 &&
            <div
                style={{
                    height: `${rowVirtualizer.getTotalSize()}px`,
                    width: '100%',
                    position: 'relative',
                }}>
                {/*<div*/}
                {/*    style={{*/}
                {/*        position: 'absolute',*/}
                {/*        top: 0,*/}
                {/*        left: 0,*/}
                {/*        width: '100%',*/}
                {/*        transform: `translateY(${virtualItems[0].start}px)`,*/}
                {/*    }}*/}
                {/*>*/}
                {virtualItems.map((virtualRow) => {
                    const isLoaderRow = virtualRow.index === items.length;
                    const item = items[virtualRow.index]

                    return (<div  key={virtualRow.key}
                                  data-index={virtualRow.index}
                                  style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: `${virtualRow.size}px`,
                                      transform: `translateY(${virtualRow.start}px)`,
                                  }}
                    >
                        {isLoaderRow && <>
                            {hasNextPage && items.length < nbHits && <InfiniteListLastItem hasNextPage={hasNextPage} height={itemHeight}/>}
                            {/*{!hasNextPage && <>Loaded</>}*/}
                        </>}
                        {!isLoaderRow && <SearchListItemResult
                            index={virtualRow.index}
                            item={item}
                            screenName={screenName}
                            showPrice={showPrice}
                            forceSmall={forceSmall}
                            setShowAuthAlert={setShowAuthAlert}
                            customerRoutes={data?.user?.customerRoutes}
                            key={auth.getUniqUserKey() + '-' + item.id}
                        />}
                        {virtualRow.index === items.length-1 && <InfiniteListLastItem hasNextPage={hasNextPage} height={itemHeight} isFetchingNextPage={isFetchingNextPage} loadMore={loadMore}/>}
                    </div>);
                })}

            </div>}
        </div>
    )
};

export default withTranslation()(ListComponent);
